angular.module('appMarketplace')
    .service('HelpService', ['$http', 'UrlService', function ($http, UrlService) {
        var service = this;

        service.getVersionInfo = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/help/versionInfo'),
                cache: true
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(error) {
                errorCallback(error)
            })
        };

        service.sendFeedback = function (feedback, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/feedback'),
                data: feedback
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.getReleasePageUrl = function () {
            return UrlService.createAbsoluteUrl('/release.jsp');
        }
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/help-service.js
// module id = 267
// module chunks = 17